import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, Github, Download, PlayCircle, FileText, Play } from 'lucide-react';
import { isSelfHosted } from '../../utils/appSchema';
import { prettyUrl } from '../../utils/format';
import { trackEvent } from '../../utils/analytics';

const SECONDARY_LINKS = [
    { key: 'githubUrl', label: 'Mã nguồn trên GitHub', icon: Github },
    { key: 'downloadUrl', label: 'Tải về', icon: Download },
    { key: 'videoUrl', label: 'Xem video giới thiệu', icon: PlayCircle },
    { key: 'docsUrl', label: 'Tài liệu hướng dẫn', icon: FileText },
];

/**
 * Cụm nút hành động ở trang giới thiệu: nút chính để mở ứng dụng,
 * bên dưới là các liên kết phụ (GitHub, tải về, video, tài liệu).
 */
const AppActions = ({ app }) => {
    const selfHosted = isSelfHosted(app);
    const track = (label) => trackEvent('app_link_click', 'apps', `${app.title} — ${label}`);

    const secondary = SECONDARY_LINKS.filter(({ key }) => app[key]);

    return (
        <div className="space-y-3">
            {app.externalUrl && (
                <a
                    href={app.externalUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => track('mở ứng dụng')}
                    className="btn-accent w-full py-4"
                >
                    <ExternalLink className="w-5 h-5" />
                    Mở ứng dụng
                </a>
            )}

            {selfHosted && (
                <Link
                    to={`/app/${app.id}/mo`}
                    onClick={() => track('dùng thử tại chỗ')}
                    className="btn-accent w-full py-4"
                >
                    <Play className="w-5 h-5" />
                    Dùng thử ngay
                </Link>
            )}

            {!app.externalUrl && !selfHosted && app.githubUrl && (
                <a
                    href={app.githubUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => track('github')}
                    className="btn-accent w-full py-4"
                >
                    <Github className="w-5 h-5" />
                    Xem trên GitHub
                </a>
            )}

            {secondary.map(({ key, label, icon: Icon }) => (
                <a
                    key={key}
                    href={app[key]}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => track(label)}
                    className="w-full flex items-center gap-3 px-4 py-3 bg-white/60 dark:bg-white/[0.05] backdrop-blur-sm border border-white/50 dark:border-white/[0.08] rounded-xl hover:bg-white/80 dark:hover:bg-white/[0.09] transition-all group"
                >
                    <Icon className="w-[18px] h-[18px] text-slate-500 dark:text-slate-400 shrink-0" />
                    <span className="flex-1 min-w-0">
                        <span className="block text-sm font-medium text-slate-800 dark:text-slate-100">{label}</span>
                        <span className="block text-xs text-slate-400 dark:text-slate-500 truncate">
                            {prettyUrl(app[key])}
                        </span>
                    </span>
                    <ExternalLink className="w-4 h-4 text-slate-300 dark:text-slate-600 group-hover:text-slate-500 transition-colors shrink-0" />
                </a>
            ))}
        </div>
    );
};

export default AppActions;
